/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext } from 'react';

import { siteModalToModal } from '@toucan/services/adapters/contentful';

import MpbLogo from '@toucan/icons/legacy/mpb-logo.svg';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { Link } from '@toucan/client/shared/components/link';

import { ProductTrustCard } from '../product-trust-card';
import { MpbApprovedProps } from './types';

export const DEFAULT_TEST_ID = 'mpb-approved';

export const MpbApproved: FunctionComponent<MpbApprovedProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    learnCheckingProcess,
    ...otherProps
}: MpbApprovedProps) => {
    const { t } = useTranslation();
    const { setModalContent, setModalSize, setModalVisible } =
        useContext(ApplicationContext);

    const checkingProcessModal = siteModalToModal(learnCheckingProcess);

    /**
     * Opens the modal and sets the content when the 'Learn about our checking process'
     * button is clicked
     */
    function handleProcessClick() {
        setModalSize(ModalSize.LARGE);
        setModalContent(checkingProcessModal);
        setModalVisible(true);
    }

    return (
        <ProductTrustCard
            data-testid={dataTestId}
            heading={t('MPB approved')}
            icon={<MpbLogo />}
        >
            <p data-testid={`${dataTestId}__message`}>
                {t(
                    'This item was thoroughly checked, approved and photographed by our team of product specialists in our Brighton warehouse.'
                )}
            </p>
            <Link onClick={handleProcessClick}>
                {t('Learn about our checking process')}
            </Link>
        </ProductTrustCard>
    );
};
